// extracted by mini-css-extract-plugin
module.exports = {"form":"Trends_form__jaeNv","btn_remove":"Trends_btn_remove__1FXjL","btn_add":"Trends_btn_add__OYI8L","trash":"Trends_trash__28zzF","container":"Trends_container__z724m"};